import { useNavigate, useParams } from "react-router-dom";
import Header from "../components/Header";
import { t } from "../app/Translate";
import Footer from "../components/Footer";
import { motion } from "framer-motion";

import opcion1 from '../svg/01_M-FACT-CW.svg';
import opcion2 from '../svg/q_M-INV-CY.svg';
import opcion3 from '../svg/01_M-TES-CW.svg';
import opcion4 from '../svg/01_M-CONT-CW.svg';
import opcion5 from '../svg/01_M-INFOR-CW.svg';
import opcion6 from '../svg/01_M-Avanzados-CW.svg';

import svg1 from '../svg/F-Bene1-CP.svg';
import svg2 from '../svg/F-Bene2-CP.svg';
import svg3 from '../svg/F-Bene3-CP.svg';
import svg4 from '../svg/F-Bene4-CP.svg';

const Inventory = () => {     
    const {isocode}: any = useParams();    
    const navigate = useNavigate();
    
    function NavigateTo(){
        let urlRegister = "/" + isocode + "/plans/" 
        navigate(urlRegister);
    }

     function NavigateToNew(idRuta: string){
        let urlRegister = "/" + isocode + "/" + idRuta + "/" 
        navigate(urlRegister);
    }
    
    return(
        <>
            <Header isocode={isocode} active="functions"/>
            <main className="main-content">
                <section className="header-inventory" style={{paddingLeft:"10%"}}>
                    <div className="row" style={{paddingTop:"130px",textAlign:"left"}}>
                        <div className="col-md-6 bannertext1">
                            {t("inventory.title")}
                            <div className="bannertext2" style={{paddingRight:"50px"}}>
                                {t("inventory.subtitle")}
                            </div>                            
                        </div>                        
                        <div className="col-md-6"></div>
                    </div>         
                    <br/><br/>
                </section>

                <section className=".iconsmenuadv onlydesktop" style={{backgroundColor:"#282C40"}}>
                    <div className="row" style={{paddingLeft:"140px", paddingRight:"140px", paddingBottom:"20px"}}>
                        <div className="col-md-2" onClick={e => NavigateToNew("invoice")}>
                            <img src={opcion1} className="iconmenuadv"/>
                            <br/>
                            <span className="iconmenuadvtitle" style={{color:"#ffffff"}}>{t("menu.functions-invoices")}</span>
                        </div>
                        <div className="col-md-2">
                            <img src={opcion2} className="iconmenuadv" />
                            <br/>
                            <span className="iconmenuadvtitle" style={{color:"#F2A007"}}>{t("menu.functions-inventory")}</span>
                        </div>
                        <div className="col-md-2" onClick={e => NavigateToNew("treasury")}>
                            <img src={opcion3} className="iconmenuadv" />
                            <br/>
                            <span className="iconmenuadvtitle" style={{color:"#ffffff"}}>{t("menu.functions-treasury")}</span>
                        </div>
                        <div className="col-md-2" onClick={e => NavigateToNew("accounting")}>
                            <img src={opcion4} className="iconmenuadv" />
                            <br/>
                            <span className="iconmenuadvtitle" style={{color:"#ffffff"}}>{t("menu.functions-gestion")}</span>
                        </div>
                        <div className="col-md-2" onClick={e => NavigateToNew("statements")}>
                            <img src={opcion5} className="iconmenuadv" />
                            <br/>
                            <span className="iconmenuadvtitle" style={{color:"#ffffff"}}>{t("menu.functions-informs")}</span>
                        </div>
                        <div className="col-md-2">
                            <img src={opcion6} className="iconmenuadv" onClick={e => NavigateToNew("advanced")}/>
                            <br/>
                            <span className="iconmenuadvtitle" style={{color:"#ffffff"}}>{t("menu.advantage")}</span>
                        </div>
                    </div>
                </section>

                <section className="padingtag" style={{width:"100%",padding:"25px",backgroundColor:"#F0f1f2"}}>
                    <span style={{fontSize:"20px",color:"#282C40",lineHeight:"20px",fontWeight:"200"}}>{t("inventory.tag")}</span>
                </section>


                <section className="main-section padmakos" style={{backgroundColor:"#ffffff", textAlign:"left"}}>                    
                    <div className="row">      
                        <div className="col-md-1"></div>                     
                        <div className="col-md-5">
                            <h2 className="whymakos-title" style={{color:"#282C40", paddingLeft:"0px", paddingRight:"0px"}}>{t("inventory.why")}</h2>
                            <motion.img
                                src="../../images/M-Inventario.png"
                                style={{width:"80%"}}
                                initial={{ scale: 0, opacity: 0 }}
                                animate={{ scale: 1, opacity: 1 }}
                                transition={{ duration: 0.8, ease: "easeOut" }} 
                                whileInView={{ scale: 1, opacity: 1 }} 
                                viewport={{ once: true, amount: 0.5 }}                                 
                            />                            
                        </div>
                        <div className="col-md-5" style={{textAlign:"left"}}>                            
                            <div className="title-section1" style={{color:"#4946A6",fontSize:"20px",lineHeight:"25px"}}>
                                {t("inventory.answer1")}
                            </div>
                            <div className="body-section1" style={{color:"#282C40",fontSize:"20px", paddingTop:"15px", paddingBottom:"40px"}}>
                                {t("inventory.answer1det")}
                            </div> 

                            <div className="title-section1" style={{color:"#4946A6",fontSize:"20px",lineHeight:"25px"}}>
                                {t("inventory.answer2")}
                            </div>
                            <div className="body-section1" style={{color:"#282C40",fontSize:"20px", paddingTop:"15px", paddingBottom:"40px"}}>
                                {t("inventory.answer2det")}
                            </div>

                            <div className="title-section1" style={{color:"#4946A6",fontSize:"20px",lineHeight:"25px"}}>
                                {t("inventory.answer3")}
                            </div>
                            <div className="body-section1" style={{color:"#282C40",fontSize:"20px", paddingTop:"15px", paddingBottom:"40px"}}>
                                {t("inventory.answer3det")}
                            </div>                            
                        </div>  
                        <div className="col-md-1"></div>                                             
                    </div>
                </section>
                
                <section className="main-section padmakos" style={{backgroundColor:"#282C40", textAlign:"left"}}>                    
                    <div className="row">                        
                        <div className="col-md-12">
                            <div className="reviewcard">
                                <div className="row">
                                    <div className="col-md-6">
                                        <img className="reviewLogo" src="/images/logoreview02.png" /> 
                                        <div className="reviewbody">
                                            {t("reviews.review2")}
                                        </div>               
                                        <hr className="divider-separator3" />
                                        <div className="reviewfootercustomer">
                                            <p>{t("reviews.review2customer")}</p>
                                        </div>
                                        <div className="reviewfooterlocal">
                                            <p>{t("reviews.review2local")}</p>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <img src="/images/review02.png" className="reviewImg" /> 
                                    </div>
                                </div>
                                
                            </div>
                        </div>                        
                    </div>
                </section>        

                <section className="main-section2 padmakos">
                    <div className="row">          
                        <div className="col-md-7">
                            <motion.img
                                src="../../images/Inventario-Articulo.png"
                                className="img-section1"
                                initial={{ scale: 0, opacity: 0 }}
                                animate={{ scale: 1, opacity: 1 }}
                                transition={{ duration: 0.8, ease: "easeOut" }} 
                                whileInView={{ scale: 1, opacity: 1 }} 
                                viewport={{ once: true, amount: 0.5 }}                                 
                            />                            
                        </div>              
                        <div className="col-md-5">
                            <div className="IconSection">
                                <img src={svg1} alt="icon"/>
                            </div>
                            <div className="title-section1">
                                {t("inventory.benef1title")}
                            </div>
                            <div className="body-section1" dangerouslySetInnerHTML={{ __html: t("inventory.benef1subtitle") }} /> 
                            
                        </div>                                                                    
                    </div>
                </section>

                <section className="main-section2 padmakos">
                    <div className="row">          
                        <div className="col-md-1"></div>                                         
                        <div className="col-md-5">
                            <div className="IconSection">
                                <img src={svg2} alt="icon"/>
                            </div>
                            <div className="title-section1">
                                {t("inventory.benef2title")}
                            </div>
                            <div className="body-section1" dangerouslySetInnerHTML={{ __html: t("inventory.benef2subtitle") }} />                             
                        </div>                     
                        <div className="col-md-5">
                            <motion.img
                                src="../../images/Inventario-Alerta.png"
                                className="img-section1"
                                initial={{ scale: 0, opacity: 0 }}
                                animate={{ scale: 1, opacity: 1 }}
                                transition={{ duration: 0.8, ease: "easeOut" }} 
                                whileInView={{ scale: 1, opacity: 1 }} 
                                viewport={{ once: true, amount: 0.5 }}                                 
                            />                            
                        </div>                  
                        <div className="col-md-1"></div>                                
                    </div>
                </section>

                <section className="main-section2 padmakos">
                    <div className="row">          
                        <div className="col-md-1"></div>   
                        <div className="col-md-6">
                            <motion.img
                                src="../../images/Inventario-Categoria-4.png"
                                className="img-section1"
                                initial={{ scale: 0, opacity: 0 }}
                                animate={{ scale: 1, opacity: 1 }}
                                transition={{ duration: 0.8, ease: "easeOut" }} 
                                whileInView={{ scale: 1, opacity: 1 }} 
                                viewport={{ once: true, amount: 0.5 }}                                 
                            />                            
                        </div>              
                        <div className="col-md-4">
                            <div className="IconSection">
                                <img src={svg3} alt="icon"/>
                            </div>
                            <div className="title-section1">
                                {t("inventory.benef3title")}
                            </div>
                            <div className="body-section1" dangerouslySetInnerHTML={{ __html: t("inventory.benef3subtitle") }} />                             
                        </div>                                                                    
                        <div className="col-md-1"></div>   
                    </div>
                </section>

                <section className="main-section2 padmakos">
                    <div className="row">         
                        <div className="col-md-1"></div>                                          
                        <div className="col-md-4">
                            <div className="IconSection">
                                <img src={svg4} alt="icon"/>
                            </div>
                            <div className="title-section1">
                                {t("inventory.benef4title")}
                            </div>
                            <div className="body-section1" dangerouslySetInnerHTML={{ __html: t("inventory.benef4subtitle") }} />                             
                        </div>                     
                        <div className="col-md-6">
                            <motion.img
                                src="../../images/Inventario-Escalable.png"
                                className="img-section1"
                                initial={{ scale: 0, opacity: 0 }}
                                animate={{ scale: 1, opacity: 1 }}
                                transition={{ duration: 0.8, ease: "easeOut" }} 
                                whileInView={{ scale: 1, opacity: 1 }} 
                                viewport={{ once: true, amount: 0.5 }}                                 
                            />                            
                        </div>       
                        <div className="col-md-1"></div>                                           
                    </div>
                </section>

                <section className="main-section2 padmakos">
                    <div className="bordercolors" style={{marginTop:"40px",marginBottom:"80px"}}>
                        <div className="bordercolorsbody">
                            <div className="row" style={{padding:"10px"}}>
                                <div className="col-md-1"></div>
                                <div className="col-md-6">
                                    <div className="cta-question" style={{color:"#282C40"}}>{t("inventory.ctatitle")}</div>
                                    <div className="cta-message" style={{color:"#282C40"}}>{t("inventory.ctasubtitle")}</div>
                                </div>
                                <div className="col-md-4" style={{flexDirection:"column",display:"flex",paddingBottom:"70px", width:"100%"}}>                                                                        
                                     <center>                                    
                                        <button onClick={NavigateTo} className="animated-button" style={{width:"100%",marginTop:"10px"}}>{t("main.ctabutton")}</button>                                                                            
                                    </center>                                        
                                </div>
                                <div className="col-md-1"></div>
                            </div>                                                                     
                        </div>
                    </div>
                </section>                

                <Footer isocode={isocode} />  
            </main>
        </>
    )
}

export default Inventory;